const myMetricsKey = '/users';

export const myMetrics = () => {
  return `${myMetricsKey}/me`;
};
